import React, { useState, useEffect } from "react";
import { DataTable } from "../../../components/tables";
import { UsersDataGridCols } from "./data-grid-cols";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Select from "react-select";
import * as XLSX from "xlsx";
import { roles } from "../../../config";

const UsersList = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [usersData, setUsersData] = useState<any>([]);
  const [filteredUsers, setFilteredUsers] = useState<any>([]);
  const navigate = useNavigate();
  const [batchData, setBatchData] = useState<any>([]);
  const [formData, setFormData] = useState<any>({
    userBatchName: "",
  });

  const handleCancel = () => {
    setName("");
    setEmail("");
    setPhone("");
    setRole("");
    setFilteredUsers(usersData);
  };

  const handleSelectChange = (selectedOption: any, { name }: any) => {
    setFormData({ ...formData, [name]: selectedOption.value });
  };

  const handleSearch = () => {
    const filteredData = usersData.filter((student: any) => {
      const nameMatch =
        student.firstName.toLowerCase().includes(name.toLowerCase()) ||
        student.lastName.toLowerCase().includes(name.toLowerCase());
  
      const emailMatch = email
        ? student.email.toLowerCase().includes(email.toLowerCase())
        : true;
  
      const phoneMatch = phone
        ? student.phone.includes(phone)
        : true;
  
      const batchMatch = formData.userBatchName
        ? student.userBatchName === formData.userBatchName
        : true;
  
      const roleMatch = role
        ? student.role?.roleName
            .toLowerCase()
            .includes(role.toLowerCase())
        : true;
  
      return (
        nameMatch &&
        emailMatch &&
        phoneMatch &&
        batchMatch &&
        roleMatch
      );
    });
  
    setFilteredUsers(filteredData);
  };

  const handleCreateUser = () => {
    navigate("/admin/createuser");
  };

  useEffect(() => {
    getUsers();
  }, []);

  const deleteInfo = (userId: string) => {
    Swal.fire({
      title: "Are you sure you want to delete User",
      text: "Once deleted, you won't be able to recover this entry!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F5BE18",
      cancelButtonColor: "#000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          userId: userId,
        };
        AdminService.deleteUser(payload).then((res: any) => {
          if (res.status === "Success") {
            toast.success(res.message);
            getUsers();
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  };

  const handleEditUser = (data: any) => {
    navigate("/admin/editUser", { state: data });
  };

  const getUsers = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getAllUserDetails(data).then((res: any) => {
      if (res.status === "Success") {
        setUsersData(res.data);
        setFilteredUsers(res.data); // Initialize filteredUsers with all data
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleUserStatus = (userId: string, isActive: boolean) => {
    Swal.fire({
      title: `Are you sure you want to ${
        isActive ? "activate" : "deactivate"
      } this user?`,
      text: `User will be ${
        isActive ? "activated" : "deactivated"
      } successfully.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F5BE18",
      cancelButtonColor: "#000",
      confirmButtonText: `Yes, ${isActive ? "activate" : "deactivate"} it!`,
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          userId: userId,
          isActive: isActive,
        };

        AdminService.updateActiveFlag(payload).then((res: any) => {
          if (res.status === "Success") {
            toast.success(res.message);
            getUsers();
          } else {
            toast.error(res.message);
          }
        });
      }
    });
  };

  const bOptions = batchData?.map((type: any) => ({
    value: type.batchName,
    label: type.batchName,
  }));

  useEffect(() => {
    getMeets();
  }, []);

  const getMeets = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getAllBatch(data).then((res: any) => {
      if (res.status === "Success") {
        setBatchData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const exportData = () => {
    const ws = XLSX.utils.json_to_sheet(filteredUsers);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Register Data");

    // Set the file name
    const fileName = "RegisterList.xlsx";

    // Write the Excel file
    XLSX.writeFile(wb, fileName);
  };


  return (
    <div>
      <div className="container-fluid">
        <div className="text-end mt-5">
          <button className="btn btn-warning me-3" onClick={exportData}>
            Export
          </button>
          <button className="btn btn-success" onClick={handleCreateUser}>
            Create User
          </button>
        </div>
        <div className="row">
          <div className="col-md-10 mt-3">
            <label className="form-label d-flex justify-content-start text-start">
              <b> Users List</b>
            </label>
            <div className="d-flex">
              <input
                name="User Name"
                onChange={(e: any) => setName(e.target.value)}
                className="form-control mt-1 me-2"
                value={name}
                placeholder="Enter the User Name"
              />
              <input
                type="email" // Email input
                name="Email"
                onChange={(e: any) => setEmail(e.target.value)}
                className="form-control mt-1 me-2"
                value={email}
                placeholder="Enter the Email"
              />
              <input
                type="phone" // Phone input
                name="Phone"
                onChange={(e: any) => setPhone(e.target.value)}
                className="form-control mt-1 me-2"
                value={phone}
                placeholder="Enter the Phone"
              />
              <Select
                options={bOptions}
                name="userBatchName"
                placeholder="Select Batch"
                className="form-control mt-1 me-2"
                onChange={handleSelectChange}
              />

              {/* <div className="form-group mt-3"> */}
              {/* <label className="register-font">Select Role *</label> */}
              <select
                className={`form-control mt-2 `}
                name="role"
                value={role}
                onChange={(e: any) => setRole(e.target.value)}
              >
                <option value="">Select Role </option>
                {roles.map((role, index) => (
                  <option value={role.value} key={index}>
                    {role.name}
                  </option>
                ))}
              </select>

              {/* </div> */}

              <button
                className="btn btn-primary rounded px-4 py-1 ms-3"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="btn btn-secondary rounded ms-2 px-4 py-1"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>

        <div className="mt-5">
          <DataTable
            tableData={filteredUsers}
            TableCols={UsersDataGridCols}
            handleDeleteUser={deleteInfo}
            handleEditUser={handleEditUser}
            handleDeActive={handleUserStatus}
            handleActive={handleUserStatus}
          />
        </div>
      </div>
    </div>
  );
};

export default UsersList;
